import { Injectable, Inject } from '@angular/core';

 export class EntityDocumentDO {

	public id:Number;

	public guid:any;

	public agentId:String=null;

	public entityGuid:String=null;

	public entityDocumentID:String=null;

	public entityServiceID:String=null;

	public entityID:String=null;

	public entityImage:String=null;

	public referenceID:String=null;

	public referenceTypeCd:String=null;

	public documentTypeCd:String=null;

	public documentSubTypeCd:String=null;

	public documentCd:String=null;

	public entityImageName:String=null;

	public entityImageMimeType:String=null;

	public documentReceiptStatusCd:String=null;

	public documentRaisedBy:String=null;

	public documentStatusCd:String=null;

	public documentRecievedDt:Date=null;

	public purpose:String=null;

	public description:String=null;

	public imageURL:String=null;

	public uploadStatus:String=null;

	public documentNumber:any=null;

	public expiryDt:any=null;

	public issuingAuthority:any=null;

	public transactionNum:any=null;
	public visibilityCd:any=null;


	public get $id(): Number {
		return this.id;
	}

	public set $id(value: Number) {
		this.id = value;
	}

	public get $agentId(): String {
		return this.agentId;
	}

	public set $agentId(value: String) {
		this.agentId = value;
	}

	public get $entityGuid(): String {
		return this.entityGuid;
	}

	public set $entityGuid(value: String) {
		this.entityGuid = value;
	}

	public get $entityDocumentID(): String {
		return this.entityDocumentID;
	}

	public set $entityDocumentID(value: String) {
		this.entityDocumentID = value;
	}

	public get $entityServiceID(): String {
		return this.entityServiceID;
	}

	public set $entityServiceID(value: String) {
		this.entityServiceID = value;
	}

	public get $entityID(): String {
		return this.entityID;
	}

	public set $entityID(value: String) {
		this.entityID = value;
	}

	public get $entityImage(): String {
		return this.entityImage;
	}

	public set $entityImage(value: String) {
		this.entityImage = value;
	}

	public get $referenceID(): String {
		return this.referenceID;
	}

	public set $referenceID(value: String) {
		this.referenceID = value;
	}

	public get $referenceTypeCd(): String {
		return this.referenceTypeCd;
	}

	public set $referenceTypeCd(value: String) {
		this.referenceTypeCd = value;
	}

	public get $documentTypeCd(): String {
		return this.documentTypeCd;
	}

	public set $documentTypeCd(value: String) {
		this.documentTypeCd = value;
	}

	public get $documentSubTypeCd(): String {
		return this.documentSubTypeCd;
	}

	public set $documentSubTypeCd(value: String) {
		this.documentSubTypeCd = value;
	}

	public get $documentCd(): String {
		return this.documentCd;
	}

	public set $documentCd(value: String) {
		this.documentCd = value;
	}

	public get $entityImageName(): String {
		return this.entityImageName;
	}

	public set $entityImageName(value: String) {
		this.entityImageName = value;
	}

	public get $entityImageMimeType(): String {
		return this.entityImageMimeType;
	}

	public set $entityImageMimeType(value: String) {
		this.entityImageMimeType = value;
	}

	public get $documentReceiptStatusCd(): String {
		return this.documentReceiptStatusCd;
	}

	public set $documentReceiptStatusCd(value: String) {
		this.documentReceiptStatusCd = value;
	}

	public get $documentRaisedBy(): String {
		return this.documentRaisedBy;
	}

	public set $documentRaisedBy(value: String) {
		this.documentRaisedBy = value;
	}

	public get $documentStatusCd(): String {
		return this.documentStatusCd;
	}

	public set $documentStatusCd(value: String) {
		this.documentStatusCd = value;
	}

	public get $documentRecievedDt(): Date {
		return this.documentRecievedDt;
	}

	public set $documentRecievedDt(value: Date) {
		this.documentRecievedDt = value;
	}

	public get $purpose(): String {
		return this.purpose;
	}

	public set $purpose(value: String) {
		this.purpose = value;
	}

	public get $description(): String {
		return this.description;
	}

	public set $description(value: String) {
		this.description = value;
	}

	public get $imageURL(): String {
		return this.imageURL;
	}

	public set $imageURL(value: String) {
		this.imageURL = value;
	}

	public get $uploadStatus(): String {
		return this.uploadStatus;
	}

	public set $uploadStatus(value: String) {
		this.uploadStatus = value;
	}

}
